import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ActiveParkingSessionDTO, CalculateParkingPriceResultDTO, GetHWControlledSessionInfoForLicensePlateDTO, HWControlledSessionInfoResultDTO, IGetHWControlledSessionInfoForLicensePlateDTO, PayTillNowClient, PayTillNowStartPaymentDTO, PayTillNowStartPaymentResultDTO } from 'src/app/base/models/models.swagger.generated';

@Injectable({
  providedIn: 'root',
})
export class PayTillNowService {
  public lastParkingPriceResult: CalculateParkingPriceResultDTO | null = null;

  constructor(private payTillNowClient: PayTillNowClient,) {}

  public getHWControlledSessionInfoForLicensePlate(dtoData: IGetHWControlledSessionInfoForLicensePlateDTO): Observable<HWControlledSessionInfoResultDTO | null> {
    const dto = new GetHWControlledSessionInfoForLicensePlateDTO(dtoData);
    return this.payTillNowClient.getHWControlledSessionInfoForLicensePlate(dto).pipe(
      tap(result => this.lastParkingPriceResult = result?.session?.pricingInformation?.parkingPrice ?? null)
    );
  }

  public startPayTillNowPayment(activeParkingSession: ActiveParkingSessionDTO, email?: string, validatingParkerId?: number): Observable<PayTillNowStartPaymentResultDTO> {
    if (!activeParkingSession) {
      throw new Error('No parking price result available');
    }
    const dto = new PayTillNowStartPaymentDTO({
      sessionId: activeParkingSession.id,
      subscriptionId: activeParkingSession.subscription?.id,
      validatingParkerId: validatingParkerId,
      email: email,
      pricingInformation: activeParkingSession.pricingInformation
    });
    return this.payTillNowClient.startPayTillNowPayment(dto);
  }
}
